renderMenu(page_schema);

setView(null, [])

const checkboxes = qsa('.checkbox input');
const tags = qsa('.tags input');
const resetIcon = qs('.reset-filters-icon');
const filters = {
    "tags": new Set()
}
const hasPermaFilter = typeof permaFilter !== 'undefined';
const hasfilterPageCategory = typeof filterPageCategory != 'undefined'
if(hasfilterPageCategory){
    var sessionTitle = `${filterPageCategory}FilterTags`;
}
let savedFilters = []

function isPermaFilter(filterTag){
    let permaArray = permaFilter.split(',');
    if(permaArray.indexOf(filterTag) >= 0){
        return true;
    }
    return false
}

const resetFilters = () => {
    filters.tags.clear();
    if(hasfilterPageCategory){
        let sessionParams = { tags: [] }
        sessionStorage.setItem(sessionTitle, JSON.stringify(sessionParams));
    }
    checkboxes.forEach(checkbox => {
        const parent = checkbox.parentElement;
        checkbox.checked = false;
        parent.classList.remove('checked');
        $j(checkbox).prop('disabled', false);
    })
    const { foundProducts } = getProducts();
    setProductCount(foundProducts.length);
    setPills([]);
    insertAds()
    filterSort()
    
    if(hasPermaFilter){
        initialSelect(permaFilter)
    }

    setPills([...filters.tags]);
    
}

//Initialize filter checkboxes
checkboxes.forEach(checkbox => {
    checkbox.addEventListener('click', () => {
        if(hasPermaFilter){
            if(!isPermaFilter(checkbox.id)){
                if(typeof isFirst !== 'undefined'){
                    isFirst = false;
                }
                check_if_selected(checkbox);
            }
        }
        else{
            if(typeof isFirst !== 'undefined'){
                isFirst = false;
            }
            check_if_selected(checkbox);
        }
    })
})

const removePill = (pillName) => {
    filters.tags.delete(pillName);
    if(hasfilterPageCategory){
        removeSessionParamsTag(pillName);
        sessionStorage.setItem(sessionTitle, JSON.stringify(sessionParams));
    }

    if(hasPermaFilter){
        if(!isPermaFilter(pillName)){
            checkboxes.forEach(checkbox => {
                if (checkbox.id === pillName) {
                  checkbox.checked = false;
                  check_if_selected(checkbox);
                }
              })
        }
    }
    else{
        checkboxes.forEach(checkbox => {
            if (checkbox.id === pillName) {
              checkbox.checked = false;
              check_if_selected(checkbox);
            }
          })
    }
  
    
  
    setPills([...filters.tags]);
    insertAds()
    filterSort()
  }

function removeSessionParamsTag(tag){
    const tagIndex = sessionParams.tags.indexOf(tag)
    if (tagIndex > -1) { // only splice array when item is found
        sessionParams.tags.splice(tagIndex, 1); // 2nd parameter means remove one item only
    }
}

//Initialize filter tags
tags.forEach(tag => {
    tag.addEventListener('click', () => {
        if(tag.checked){
            filters.tags.add(tag.id)
            //Update session storage
            if(hasfilterPageCategory){
                sessionParams.tags.push(tag.id);
                sessionStorage.setItem(sessionTitle, JSON.stringify(sessionParams));
            }
        }
        else{
            filters.tags.delete(tag.id);
            if(hasfilterPageCategory){
                removeSessionParamsTag(tag.id);
                sessionStorage.setItem(sessionTitle, JSON.stringify(sessionParams));
            }
            //Update session storage
        }

        let tags = [];
        setPills([...filters.tags]);
        tags.push(...[...filters.tags]);
        
        if(hasPermaFilter){
            if(!isPermaFilter(tag.id)){
                setView(null, tags, null);
            }
        }
        else{
            setView(null, tags, null);
        }

        insertAds()
        filterSort()
    })
})

resetIcon.addEventListener('click', resetFilters);

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
//adding session storage to params
let sessionParams = []

//add a check to not do this for pages like reagents that don't have filters to select
if(hasfilterPageCategory){
    
    sessionParams = JSON.parse(sessionStorage.getItem(sessionTitle));
    if(sessionParams == null){
        //set tag session storage here
        //Add code to update sessionParams and set sessionstorage to sessionParms per tag selection 
        let setSessionObject = { tags: [] }
        sessionStorage.setItem(sessionTitle, JSON.stringify(setSessionObject));
        sessionParams = JSON.parse(sessionStorage.getItem(sessionTitle));
    }
    else{
        for(item in sessionParams.tags){
            if(params.tags == 'undefined'){
                params.tags = '';
                params.tags += sessionParams.tags[item];
            }
            else{
                params.tags += ',';
                params.tags += sessionParams.tags[item];
            }
            savedFilters.push(sessionParams.tags[item])
        }
    }
}

if (Object.keys(params).length) {
    if(hasPermaFilter){
        let permaArray = permaFilter.split(',')
        for(permaFilterIndex in permaArray){
            filters.tags.add(permaArray[permaFilterIndex]);
        }
    }
    if ('tags' in params) {
        params.tags.split(',').forEach(tag => {
            if(document.getElementById(tag)){
                filters.tags.add(tag);
                let tempProductCount = getProductCount(null, filters.tags)
                if(tempProductCount <= 0){
                    filters.tags.delete(tag);
                    if(hasfilterPageCategory){
                        removeSessionParamsTag(tag);
                        sessionStorage.setItem(sessionTitle, JSON.stringify(sessionParams));
                    }
                }
            }
        })
    }

    const { foundProducts, possibleFilters, showAll } = getProducts(null, filters.tags);

    if (foundProducts.length === 0) {
        resetFilters();
    } else {
        filters.tags.forEach(tag => {
            const tagEl = document.getElementById(tag);
            if(!document.getElementById(tag).disabled){
                tagEl.checked = true;
                check_if_selected(tagEl);
            }
        })

        hideFilters(possibleFilters, showAll);
        setProductCount(foundProducts.length);
    }
} else {
    const { foundProducts } = getProducts();
    setProductCount(foundProducts.length);

    window.onload = () => {
        qsa('input:checked').forEach(input => {
            check_if_selected(input);

            const ulElement = input.parentElement.parentElement;
            if (ulElement.classList.contains('tags')) {
                filters.tags.add(input.id);
            }
        })

        if (filters.tags.size) {
            setView(null, filters.tags);
            insertAds()
        filterSort()
        }
    }
}

function addResetPillButton(){
    let template = `<i class="fas fa-undo-alt" id="filter-pills-reset" title="Reset filters" onclick="resetFilters()"></i>`
    if(filters.tags.size > 0){
        $('#filter-pills-container').prepend(template);
    }
}

if(hasPermaFilter){
    initialSelect(permaFilter)
    setPills([...filters.tags]);
}

const lineTemplate =
`<div style="
    border-top: 0.5px solid rgba(0, 0, 0, .2);
    margin: 0.25rem 0px;
"></div>`

function insertAds(){
if(typeof ad_cards != 'undefined'){
    for(item in ad_cards){
        let adTemplate = `
        <div class="product-card" id="${item}" style="
            background-image: url('${ad_cards[item].background_image}');
            background-size: cover;
            background-repeat: no-repeat;
        ">
            <a href="${ad_cards[item].link}" rel="noopener noreferrer" style="min-height: 400px; display: block;"
            onclick="mixPanelTrack('filterPageClick', {'click': 'Advertisement Card', 'description': '${ad_cards[item].description}', 'destination': '${ad_cards[item].link}',  'version': '${filterPageVersion}' })"></a>
        </div>
        `
        var htmlObject = document.createElement('div');
        htmlObject.innerHTML = adTemplate;
        htmlObject = htmlObject.firstElementChild
        if(!document.getElementById(item)){
            if(ad_cards[item].index >= document.getElementsByClassName('product-card').length){
                document.getElementsByClassName('product-card')[document.getElementsByClassName('product-card').length - 1].after(htmlObject)
            }
            else{
                document.getElementsByClassName('product-card')[ad_cards[item].index].after(htmlObject)
            }
        }
    }
}

countFilters();
    setPills([...filters.tags]);

}

function filterSort(){
    var jsonFilterOrder = {}

    for (const filterVal of filters.tags) {
        for(product in page_schema.products){
            for(filterMatch in page_schema.products[product].filters){
                if(page_schema.products[product].filters[filterMatch].filter == filterVal){
                    jsonFilterOrder[page_schema.products[product].filters[filterMatch].index] = product;
                }
            }
        }
        let filterIndexStart = 0;
        for(item in jsonFilterOrder){
            if(document.getElementById(jsonFilterOrder[item])){
                document.getElementsByClassName('product-card')[filterIndexStart].before(document.getElementById(jsonFilterOrder[item]))
                filterIndexStart++;
            }
        }
    }
}

function initialSelect(tagName){
    window.setTimeout(function(){ window.onscroll = null; }, 100);
    const { foundProducts } = getProducts();
    setProductCount(foundProducts.length);

    let tagArray = tagName.split(',');

    for(tagIndex in tagArray){
        filters.tags.add(tagArray[tagIndex]);
    }
    
    let tags = [];
    tags.push(...[...filters.tags]);
    setView(null, tags, null);
    insertAds()
    filterSort()

    for(tagIndex in tagArray){
        document.getElementById(tagArray[tagIndex]).checked = true
    }
}

const pillCancelButtons = qsa('.filter-pill__cancel');

const onPillCancel = (button) => {
    removePill(button.parentElement.classList[0]);

    if(hasPermaFilter){
        if(!isPermaFilter(button.parentElement.classList[0])){
            setView(null, filters.tags);
        }
    }
    else{
        setView(null, filters.tags);
    }

    insertAds()
    filterSort()
}

pillCancelButtons.forEach(button => {
  button.addEventListener('click', () => { onPillCancel(button) })
})

$j(document).ready(function() {
    insertAds()
    filterSort()
});